module.exports = __webpack_public_path__ + "assets/img/mxu.c6afb99f.jpg";